import { render, staticRenderFns } from "./CreateInvoiceFrontPage.vue?vue&type=template&id=52d0a5b6"
import script from "./CreateInvoiceFrontPage.vue?vue&type=script&lang=js"
export * from "./CreateInvoiceFrontPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports